import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import Gbtn from "../../../Components/buttons/Gbtn";
import DashNav from "../../../Components/DashNav/DashNav";
import "./Publications.css";
import { FiEdit } from "react-icons/fi";
import { RiSignalWifiErrorLine, RiDeleteBin6Line } from "react-icons/ri";
import { FcDocument } from "react-icons/fc";
import { GrDocumentMissing } from "react-icons/gr";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../Components/LoadingSpinner/LoadingSpinner";
import noImage from "../../../Assests/avatar1.png";
import NewsPaper from "../../../Components/SVGS/NewsPaper";
import { getAllPublications } from "../../../api";

function Publications() {
  const icon = () => {
    return <NewsPaper size="26" height="30" fill="#DF2F35" />;
  };

  const location = useLocation();
  const CurrPage =
    location.state && location.state ? location.state.page : null;

  const navigate = useNavigate("");
  const addOnclick = () => {
    navigate("/dashboard/Publications/add");
  };

  const [page, setPage] = useState(CurrPage !== null ? CurrPage : 1);
  const [limit, setLimit] = useState(10);
  const [totalRecords, setTotalRecords] = useState(10);
  const [publications, setPublications] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [paginationDisplay, setPaginationDisplay] = useState("block");
  const [err, setErr] = useState(false);
  const [searchString, setSearchString] = useState("");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    fetchData(page);
    // setPublications(arr);
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      if (searchString.trim() !== "") fetchData(page, searchString);
    }, 1500);
    return () => {
      clearTimeout(delay);
    };
  }, [searchString]);

  const fetchData = (pageNumber, searchTxt) => {
    setisLoading(true);
    setErr(false);
    getAllPublications(limit, pageNumber, searchTxt)
      .then(({ data }) => {
        setisLoading(false);
        if (data.success) {
          setPublications(data.result);
          setTotalRecords(data.total_records);
          setPaginationDisplay("block");
          setPage(pageNumber);
        } else {
          if (data.error_code === 2) {
            setPublications(data.result);
            setErrorMsg(data.message);
          } else {
            setErr(true);
            setErrorMsg(data.message);
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
        setErr(true);
        setPaginationDisplay("none");
        setErrorMsg(err.message);
        setisLoading(false);
      });
  };

  const handlePageChange = (pageNumber) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    if (pageNumber >= 1) {
      setPage(pageNumber);
      fetchData(pageNumber, searchString);
    }
  };

  const handleSearch = (e) => {
    setSearchString(e.target.value);
    if (e.target.value === "") {
      fetchData(page);
    }
  };

  return (
    <>
      <div className="mainDashView">
        <div>
          <DashNav svg={icon} DashboardNavText="Publications" />
        </div>

        <div className="dashPanel border-lt-Gray">
          <div className="r-ViewBar">
            <div className="r-ViewBar2">
              <div>
                <input
                  type="search"
                  value={searchString}
                  onChange={handleSearch}
                  placeholder="Search"
                  className="rolesSearch"
                />
              </div>
            </div>
            <div className="r-View-btn">
              <Gbtn
                text="Add"
                color="#DF2F35"
                radius="5px"
                width="200px"
                func={addOnclick}
              />
            </div>
          </div>
          {isLoading ? (
            <div>
              <LoadingSpinner />
            </div>
          ) : err ? (
            <div className="network-err-msg">
              <RiSignalWifiErrorLine /> {errorMsg}
            </div>
          ) : publications && publications.length !== 0 ? (
            <div className="tableContainer">
              <table className="roleViewTable" style={{ minWidth: "100%" }}>
                <thead>
                  <tr>
                    <th>Actions</th>
                    <th>Uploaded Document</th>
                    <th>Thumbnail</th>
                    <th>Title</th>
                    <th>View Abstract</th>
                    <th>Authors</th>
                    <th>Overview</th>
                    <th style={{ paddingRight: "20px" }}>Posted Date</th>
                  </tr>
                </thead>
                <tbody>
                  {publications &&
                    publications.map((data) => (
                      <Rows data={data} currentPage={page} />
                    ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="network-err-msg">{errorMsg}!</div>
          )}
          <div className="paginationDiv" style={{ display: paginationDisplay }}>
            <Pagination
              activePage={page}
              itemsCountPerPage={limit}
              totalItemsCount={totalRecords}
              pageRangeDisplayed={3}
              onChange={(pageNumber) => {
                handlePageChange(pageNumber);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
const Rows = ({ data, currentPage }) => {
  const navigate = useNavigate();
  const editRole = () => {
    navigate("/dashboard/Publications/edit", {
      state: { publicationsToEdit: data, page: currentPage },
    });
  };
  const delRole = () => {
    navigate("/dashboard/Publications/delete", {
      state: { publicationsToEdit: data, page: currentPage },
    });
  };

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [imgErr, setImgErr] = useState(false);

  const handleImageErr = () => {
    setImgErr(true);
  };

  const getDate = (datee) => {
    const date = new Date(datee);

    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

    // This arrangement can be altered based on how we want the date's format to appear.
    return `${day}-${month}-${year}`;
  };

  return (
    <>
      {data && data ? (
        <tr>
          <td
            style={{
              minWidth: "60px",
            }}
          >
            <div style={{ display: "flex" }}>
              <button onClick={editRole} className="Actionbtn editBtn">
                <FiEdit />
              </button>
              <button onClick={delRole} className="Actionbtn delBtn">
                <RiDeleteBin6Line />
              </button>
            </div>
          </td>
          <td>
            {data.document_path &&
            data.document_path !== "" &&
            data.document_path !== "null" ? (
              <FcDocument size={32} />
            ) : (
              <GrDocumentMissing size={27} />
            )}
            {/* <img
              src={imgErr ? noImage : data.upload_doc_doc}
              onError={handleImageErr}
              alt=""
              height={"28"}
              width={"28"}
              style={{
                borderRadius: "100%",
                border: "1px solid lightgray",
                borderBlockColor: "lightgray",
              }}
            /> */}
          </td>
          <td>
            <img
              src={imgErr ? noImage : baseUrl + data.image_path}
              onError={handleImageErr}
              alt=""
              height={"28"}
              width={"28"}
              style={{
                borderRadius: "100%",
                border: "1px solid lightgray",
                borderBlockColor: "lightgray",
              }}
            />
          </td>
          <td className="break-line-170">{data.title}</td>
          <td className="break-line-170">{data.abstract_link}</td>
          <td>
            <div className="CC-hover">View</div>
            <div className="cc-hoverShow">
              {data && data.author_publicaton.length !== 0
                ? data.author_publicaton.map((author, index) => (
                    <AuthorView author={author} key={index} />
                  ))
                : " No Authors listed"}
            </div>
          </td>
          <td className="break-line-200">
            {data.overview && data.overview.length > 120
              ? data.overview.substring(0, 120) + "..."
              : data.overview}
          </td>
          <td style={{ paddingRight: "20px" }}>{getDate(data.created_on)}</td>
        </tr>
      ) : null}
    </>
  );
};

const AuthorView = ({ author, key }) => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [imageErr, setImageErr] = useState(false);
  const handleImageErr = () => {
    setImageErr(true);
  };
  return (
    <div
      key={key}
      style={{
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        marginBottom: "7px",
      }}
    >
      <span>
        <img
          src={imageErr ? noImage : baseUrl + author.author.image_path}
          onError={handleImageErr}
          alt="img"
          height={25}
          width={25}
          className="author-hover-view-img"
        />
      </span>
      <span className="break-line-270">
        {author.author.name.length > 16
          ? author.author.name.substring(0, 14) + "..."
          : author.author.name}
      </span>
    </div>
  );
};

export default Publications;
